module.exports = __webpack_public_path__ + "trash-2.svg";